export const peerMuteHandler = (msgData, store, roomClient) => {
  if (msgData.peerId !== roomClient._peerId) {
    const payload = { id: msgData.peerToMute, micPaused: msgData.micPaused };
    store.commit("mediasoup/set_peer_micPaused", payload);
  }
};

export const peerVideoMuteHandler = (msgData, store, roomClient) => {
  if (msgData.peerId !== roomClient._peerId) {
    const payload = { id: msgData.peerToMute, vidPaused: msgData.vidPaused };
    store.commit("mediasoup/set_peer_vidPaused", payload);
  }
};

export const setSpotlightHandler = (msgData, store) => {
  // Sets new spotlight
  if (!store.getters["mediasoup/isSpotlight"] && msgData.spotlightPeerId !== null) {
    store.commit("mediasoup/set_spotlight_peerId", msgData.spotlightPeerId);
    store.commit("mediasoup/set_spotlight");
  }
  // switches spotlight
  else if (
    store.getters["mediasoup/getSpotlightPeerId"] !== msgData.spotlightPeerId &&
    msgData.spotlightPeerId !== null
  ) {
    store.commit("mediasoup/set_spotlight_peerId", msgData.spotlightPeerId);
  }
  // Removes spotlight
  else {
    store.commit("mediasoup/set_spotlight_peerId", null);
    store.commit("mediasoup/remove_spotlight");
  }
};

export const maxParticipantsHandler = (store) => {
  store.commit("mediasoup/set_maxParticipantsNotification", true);
};

export const setHandRaisedHandler = (msgData, store) => {
  store.commit("mediasoup/set_handRaised", { id: msgData.id, handRaised: msgData.handRaised });
};

export const peerOnAirHandler = (msgData, store, roomClient) => {
  if (msgData.peerId !== roomClient._peerId) {
    const payload = { id: msgData.onAirId, onAir: msgData.onAir };
    store.commit("mediasoup/set_peer_onAir", payload);
  }
};

export const presentationStartedHandler = (msgData, store) => {
  store.commit("mediasoup/start_presentation", msgData.presenterId);
};

export const presentationStoppedHandler = (msgData, store, roomClient) => {
  store.commit("mediasoup/stop_presentation");
  store.commit("mediasoup/remove_screen_consumer", msgData.presenterId);
  store.commit("mediasoup/remove_screen_audio_consumer", msgData.presenterId);
  if (msgData.presenterId === roomClient._peerId) {
    roomClient.disableShare();
    store.commit("mediasoup/set_sharing", false);
  }
};

export const currentConferenceStateHandler = (msgData, store) => {
  if (msgData.isPresentation) {
    store.commit("mediasoup/start_presentation", msgData.presenterId);
  }
  if (msgData.isSpotlight) {
    store.commit("mediasoup/set_spotlight");
    store.commit("mediasoup/set_spotlight_peerId", msgData.spotlightPeerId);
  }
};

export const changedProduceLangHandler = (msgData, store, roomClient) => {
  if (msgData.peerId !== roomClient._peerId) {
    const payload = { id: msgData.peerChanged, produceLang: msgData.lang };
    store.commit("mediasoup/set_clientTranslatorOut", { id: msgData.peerChanged, currentOutputLang: msgData.lang });
    store.commit("mediasoup/set_peer_produce_lang", payload);
  }
};

export const changedConsumeLangHandler = (msgData, store, roomClient) => {
  if (msgData.peerId !== roomClient._peerId) {
    const payload = { id: msgData.peerChanged, consumeLang: msgData.lang };
    store.commit("mediasoup/set_peer_consume_lang", payload);
  }
};

export const remoteOffAirHandler = (msgData, store, roomClient) => {
  store.commit("mediasoup/set_onAir", false);
  if (msgData.forced) {
    store.commit("mediasoup/set_forceTakeover", `User: "${msgData.displayName}" forced took over the interpretation!`);
  }
  roomClient.setOnAir(false);
};

export const activeRequestAcceptedHandler = (msgData, store) => {
  store.commit("mediasoup/set_activeRequestAccepted", true);
  store.commit("mediasoup/set_activeRequestAnswererId", msgData.answererId);
  store.commit("mediasoup/set_activeRequestAnswererName", msgData.answererName);
};

export const activeRequestRejectedHandler = (msgData, store) => {
  store.commit("mediasoup/set_activeRequestRejected", true);
  store.commit("mediasoup/set_activeRequestAnswererId", msgData.answererId);
  store.commit("mediasoup/set_activeRequestAnswererName", msgData.answererName);
};

export const passiveRequestAcceptedHandler = (msgData, store) => {
  store.commit("mediasoup/set_passiveRequestAccepted", true);
  store.commit("mediasoup/set_passiveRequestPending", false);
};

export const passiveRequestRejectedHandler = (msgData, store) => {
  store.commit("mediasoup/set_passiveRequestRejected", true);
  store.commit("mediasoup/set_passiveRequestPending", false);
  store.commit("mediasoup/set_translatorReady", false);
};

export const allowedSwitchToHostHandler = (msgData, store) => {
  store.commit("mediasoup/set_allowedToSpeak", { viewerId: msgData.viewerId, allowedToSpeak: true });
};

export const switchToHostHandler = (msgData, store) => {
  store.commit("mediasoup/set_peer_role", { id: msgData.newHostId, role: "host" });
};

export const switchToViewerHandler = (msgData, store, roomClient) => {
  if (msgData.newViewerId === roomClient._peerId) {
    roomClient.switchToViewer(msgData);
  } else {
    store.commit("mediasoup/set_peer_role", { id: msgData.newViewerId, role: "viewer" });
    store.commit("mediasoup/set_allowedToSpeak", { viewerId: msgData.newViewerId, allowedToSpeak: false });
    store.commit("mediasoup/set_reqToSpeakOngoing", { requesterId: msgData.newViewerId, reqToSpeakOngoing: false });
  }
};

export const reqToSpeakOngoingHandler = (msgData, store) => {
  store.commit("mediasoup/set_reqToSpeakOngoing", { requesterId: msgData.requesterId, reqToSpeakOngoing: true });
};

export const activeSpeakerHandler = (msgData, store) => {
  const payload = { id: msgData.activeSpeakerId, volume: msgData.volume };
  store.commit("mediasoup/set_activeSpeaker", payload);
};

export const connectionStrengthHandler = (msgData, store) => {
  store.commit("mediasoup/set_peer_connectionType", msgData);
};

export const setLastAliveHandler = (msgData, store) => {
  store.commit("mediasoup/set_lastAlive", { id: msgData.id, lastAlive: msgData.lastAlive });
};
